<template>
    <div>
        <van-list  v-for="(item, index) in data" :key="index">
            <div class="card-cell" @click="handleClickItem(item)">
                <van-icon name="arrow" class="arrow-icon" />
                <van-cell is-link>
                    <template #title>
                        <span style="font-size: 15px;font-weight: 500;">单号-{{ item.pickNumber }}</span>
                    </template>
                    <template #right-icon>
                        <template v-if="isHaveToUpload(item)">
                            <van-tag type="warning" size="medium">待上传</van-tag>
                            <van-tag style="margin-left: -2px;" closeable size="medium" type="warning"
                                @close="clearStoreItem(item)">清除</van-tag>
                        </template>
                        <van-tag v-else type="primary" plain size="medium">待领取</van-tag>
                    </template>
                </van-cell>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="销售订单：" :value="item.orderNo" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="物料名称：" :value="item.matName" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="车型：" :value="item.vehicleModel" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="车牌号：" :value="item.numberPlate" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="10">
                        <van-cell class="inner-cell" title="姓名：" :value="item.driver" />
                    </van-col>
                    <van-col span="14">
                        <van-cell class="inner-cell" :title-style="{ width: '50px' }" title="电话：" :value="item.phoneNumber" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="装货日期: "
                            :value="item.createTime | formatDate('yyyy/MM/dd HH:mm')" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="装货地：" :value="item.loadingRoute" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title=" 承运公司：" :value="item.shipperName" />
                    </van-col>
                </van-row>
                <van-row type="flex" gutter="6">
                    <van-col span="24">
                        <van-cell class="inner-cell" title="收货地：" :value="item.unloadingRoute" />
                    </van-col>
                </van-row>

                <!-- 新增领取按钮 -->
                <van-button v-if="activeName === '1'" class="claim-button" type="info" size="small" plain
                    @click.stop="handleClaim(item)">
                    领取工单
                </van-button>
            </div>
        </van-list>
        <van-empty v-show="!data.length" description="暂无数据"></van-empty>
        <!-- <component v-show="activeName!='1'" :active-name="activeName" :is="dynamicComponent" /> -->
    </div>
</template>

<script>
import { Search, List, CellGroup, Cell, Row, Col, Icon, Tag, Tabs, Tab, Sticky, Empty, Notify, Button } from 'vant';
import mixin_ossign from '@/common/mixin_ossign.js';
import _ from 'lodash';

import monitor from '../mixins/monitor';
export default {
    mixins: [monitor, mixin_ossign],
    components: {
        [Search.name]: Search,
        [List.name]: List,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [Tag.name]: Tag,
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [Sticky.name]: Sticky,
        [Empty.name]: Empty,
        [Notify.name]: Notify,

        [Button.name]: Button
    },
    props: {
        activeName: {
            type: String,
            default: '1'
        },
        keyword: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            online: navigator.onLine,
            list: [],
            storedData: [],
            isApp: '',//区分是消息推送点入还是app打开
            debouncedLoadData: _.debounce(() => {
                this.loadData();
            }, 1000)
        };
    },
    created() {
        this.isApp = navigator.userAgent.indexOf('demeter/') != -1 ? 'app' : '';//是否在中
    },
    computed: {
        data() {
            if (!this.keyword) {
                return this.list;
            }
            return this.list.filter((item) => {
                return item.pickNumber.includes(this.keyword);
            });
        },
        dynamicComponent() {
            // 根据不同的 activeName 返回不同的组件,拣货状态---1待拣货 2已完成 3已取消
            switch (this.activeName) {
                case '1':
                    return '';
                case '2':
                    return 'Complete';
                case '4':
                    return 'Start';
                default:
                    return '';
            }
        }
    },
    methods: {
        handleOnline() {
            this.online = true;
            Notify({ type: 'success', message: '系统检测到网络连接恢复' });
            this.debouncedLoadData();
        },
        handleOffline() {
            this.online = false;
            Notify({ type: 'warning', message: '系统检测到网络连接断开' });
        },
        changeTab(name) {
            this.loadData();
            this.$jsbridge.call('setTitle', { title: '拣货工单' }, null);
        },
        isHaveToUpload(item) {
            // 判断是否有未上传的图片
            return item.fileList && item.fileList.length && item.fileList.some(item => {
                return item.content.indexOf('data:image/') === 0 && item.file;
            });
        },
        async uploadData() {
            let tempList = this.list.slice(0);
            // 上传数据的方法
            for (let i = 0; i < tempList.length; i++) {
                if (tempList[i].pictureUrlList && tempList[i].pictureUrlList.length) {
                    await this.update(tempList[i], this.deleteLocalListById)
                } else if (tempList[i].fileList && tempList[i].fileList.length) {
                    let uploadItem = await this.uploadFile(tempList, i);
                    await this.update(uploadItem, this.deleteLocalListById)
                }
            }
        },
        uploadToOss(file) {
            return new Promise((resolve, reject) => {
                this.uploadImg(file, {
                    firstDir: 'report',
                    secondDir: 'PICK_LIST',
                }).then((res) => {
                    file.status = 'done';
                    file.message = '上传成功';
                    delete file.content;
                    resolve(file)
                }).catch((err) => {
                    reject('上传失败');
                    // file.status = 'failed';
                    // file.message = '上传失败';
                });
            });
        },
        async uploadFile(tempList, i) {
            // 上传单个文件的方法
            return new Promise(async (resolve, reject) => {
                for (let j = 0; j < tempList[i].fileList.length; j++) {
                    if (j == 0) {
                        tempList[i].pictureUrlList = [];
                    }
                    let file = await this.uploadToOss(tempList[i].fileList[j]);
                    console.log('上传成功', file);
                    tempList[i].pictureUrlList.push(file['osskey']);
                }
                await this.updateMonitorData(tempList[i]);
                resolve(tempList[i]);
            })

        },
        async update(data, callback) {
            // 提交数据的方法
            return new Promise((resolve, reject) => {
                console.log('id为' + ',数据,单号为' + data.pickNumber + '的数据');
                this.axios.post('/report/monitor/pickList/submit', data).then((json) => {
                    if (json.statusCode == '0') {
                        callback && callback(data.pickNumber);
                        resolve();
                    } else {
                        resolve();
                    }
                })
            });
        },
        deleteLocalListById(pickNumber) {
            // 根据 pickNumber 删除本地列表项
            this.deleteMonitorData(pickNumber).then(() => {
                let i = this.list.findIndex(item => item.pickNumber === pickNumber);
                this.list.splice(i, 1);
                console.log('已删除 pickNumber 为 ' + pickNumber + ' 的数据');
            });
        },
        // 加载数据
        async loadData() {
            if (!this.online) {
                console.log('getMonitorData');

                this.list = await this.getMonitorData();
                return;
            }
            this.axios.get('/report/monitor/pickList/queryPageList', {
                params: {
                    pagable: false,
                    source: this.isApp,
                    status: this.activeName
                },
                handleErrorsYourself: true
            }).then(async json => {
                if (json.statusCode == '0') {

                    this.list = (json.list || []).map((item) => {
                        // 使用 pickNumber 作为唯一标识符
                        item.timestamp = json.timestamp;
                        return item;
                    });
                    await this.initDataBaseToList();
                    await this.uploadData();
                } else {
                    if (json.statusCode == "1") {
                        this.$toast(json.statusDesc);
                        this.list = []
                    } else {
                        this.$toast(json.statusDesc + ',加载数据失败');
                        this.list = await this.getMonitorData();
                    }
                }
            }).catch(async (err) => {
                this.$toast(err + ',加载数据失败');
                this.list = await this.getMonitorData();
            });
        },
        async initDataBaseToList() {
            let base = await this.getMonitorData();
            if (base.length) {
                this.list = this.list.map((item) => {
                    let i = base.findIndex((element) => {
                        return element.pickNumber == item.pickNumber && element.fileList && element.fileList.length;
                    });
                    if (i >= 0) {
                        let { fileList, saveTime, pictureUrlList, remark, startTime } = base[i];
                        return {
                            ...item,
                            fileList,
                            saveTime,
                            remark,
                            pictureUrlList: pictureUrlList ? pictureUrlList : [],
                            startTime
                        }
                    } else {
                        return item;
                    }
                });
            }
            await this.clearMonitorData();
            await this.addBatchMonitorData(this.list);
        },

        handleClickItem(item) {
            // let upload = 0;
            // if(this.isHaveToUpload(item)){
            //     upload = 1;
            // }
            // // 处理点击事件，根据 activeName 跳转不同的页面
            // this.$router.push({
            //     path: '/workbench-palletMonitor-detail',
            //     query: { pickNumber: item.pickNumber, activeName: this.activeName, upload } // 使用 pickNumber
            // });
        },
        clearStoreItem(item) {
            const _that = this;
            this.$dialog.confirm({
                title: '温馨提示',
                message: '确认后该条数据的暂存数据将会清除，是否确认清除？',
            }).then(async () => {
                this.list = this.list.map((element) => {
                    if (element.pickNumber == item.pickNumber) {
                        delete element.fileList;
                        delete element.saveTime;
                        delete element.pictureUrlList;
                        return element;
                    }
                    return element;
                })
                item.fileList = [];
                item.saveTime = '';
                item.pictureUrlList = [];
                await _that.updateMonitorData(item);
            }).catch(() => {
                // on cancel
            });
        },
        async handleClaim(item) {
            if (!this.online) {
                item.startTime = new Date()
                item.isClaim = true;
                await this.updateMonitorData(item);
                this.list = await this.getMonitorData();
                this.$toast.success('领取成功');
                return;
            }
            try {
                const formData = new FormData();
                formData.append('pickNumber', item.pickNumber);
                this.axios.post('/report/monitor/pickList/receive', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(res => {
                    if (res.statusCode == 0) {
                        this.$toast.success('领取成功');
                        this.loadData(); // 刷新列表
                    }
                }).catch(err => {
                    this.$toast.fail('领取失败');
                })
            } catch (error) {
                this.$toast.fail('领取失败');
            }
        },

    },
    mounted() {
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);

        this.$util.setToken(() => {
            this.loadData();
        });
    },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    beforeDestroy() {
        // 移除监听器
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
        
    }
};
</script>

<style scoped>
.card-cell {
    margin: 5px 10px;
    padding: 5px;
    border: 1px solid #efefef;
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    padding-bottom: 40px;
}

.card-cell .arrow-icon {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    font-size: 24px;
    color: #ccc;
    z-index: 1;
}

.card-cell .inner-cell {
    padding: 2px 0px;
}

.card-cell .inner-cell .van-cell__title {
    width: 70px;
    flex: none;
    text-align: left;
}

.card-cell .inner-cell .van-cell__value {
    text-align: left;
    color: #787878
}

.claim-button {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
}
</style>